export const localization = {
  pt: {
    header: 'DEUs do contrato {0}',
    locale: 'pt-BR',
    currency: 'BRL',
    monthPlaceholder: 'Mês',
    compiledDailyEngagedUsersInformation: {
      title: 'Consumo de DEUs (Daily Engaged Users) em {0}',
      partialUsage: 'Consumo parcial',
      about: 'De {0} a {1}',
      noContent: 'Os dados de {0} vão estar disponíveis a partir do dia 2.',
      planInformation: 'Plano {0} DEUs',
      filter: 'Use o filtro para ver o total de atendentes acionados em cada mês.',
      spentPercentage: '{0}% de DEUs utilizados incluídos no plano',
      overspentMessages: 'DEUs excedentes',
      progressContentHoverIcon: 'Daily Engaged Users (DEU) ou usuários enganjados diários são contabilizados uma única vez quando os usuários entram em contato com o chatbot, sendo considerado o período entre as 00:00 e 23:59 do mesmo dia.',
      totalUsed: 'Total Utilizado',
      overspentWarningMessage: 'O limite de DEUs do plano acabou.',
      overspentWarningFeeDetails: 'Mas você pode continuar usando seu plano! Os DEUs excedentes estão sendo contabilizados.',
      overspentWarningFeeDetailsWithValues: 'Mas você pode continuar usando seu plano! Será cobrado {0} para cada DEU excedente.',
      baseValueLabel: 'Valor base do plano',
      totalMonthlyLabel: 'Total de DEUs por mês',
      totalMonthlyValue: '{0} DEUs',
      overspentCostLabel: 'Custo por DEUs excedente',
      overspentCostValue: '{0} por DEU',
      month: [
        'Janeiro',
        'Fevereiro',
        'Março',
        'Abril',
        'Maio',
        'Junho',
        'Julho',
        'Agosto',
        'Setembro',
        'Outubro',
        'Novembro',
        'Dezembro',
      ],
    },
    chatbotDailyEngagedUsersConsuption: {
      title: 'Chatbots',
      about: 'Acompanhe o consumo por DEUs por chatbot',
      columnChatbot: 'ID - Chatbot',
      columnDailyEngagedUsers: 'DEUs',
      buttonAllChatbots: 'Ver mais',
    },
    dailyUsage: {
      title: 'Contabilização diária de usuários enganjados',
      buttonTitle: 'Ver mais',
      tableInformation: 'Abaixo estão detalhadas mais informações do contrato.',
      byDaily: {
        date: 'Data',
        DailyEngagedUsers: 'DEUs',
      },
    },      
  },
  en: {
    header: 'DEUs from {0} contract',
    locale: 'en-US',
    currency: 'BRL',
    monthPlaceholder: 'Month',
    compiledDailyEngagedUserInformation: {
      title: 'Consumption by DEUs (Daily Engaged Users)',
      partialUsage: 'Partial consumption',
      about: 'From {0} to {1}',
      noContent: 'The data for {0} will be available from the 2nd.',
      planInformation: 'Plan {0} DEUs',
      filter: 'Use the filter to view the total number of activated agents each month.',
      spentPercentage: '{0}% of DEUs used included in the plan',
      overspentMessages: 'Overflow DEUs',
      progressContentHoverIcon: 'Daily Engaged Users (DEU) are counted a single time, when users contact the chatbot within a period between 00:00 and 23:59 of the same day.',
      totalUsed: 'Total used',
      overspentWarningMessage: 'The plan\'s DEU limit is over.',
      overspentWarningFeeDetails: 'But you can keep using your plan! The overflow DEUs are being booked.',
      overspentWarningFeeDetailsWithValues: 'But you can keep using your plan! {0} will be charged for each overflow DEU.',      
      baseValueLabel: 'Base value of the plan',
      totalMonthlyLabel: 'Total DEUs per month',
      totalMonthlyValue: '{0} DEUs',
      overspentCostLabel: 'Cost per overflow DEUs',
      overspentCostValue: '{0} per DEU',
      month: [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December',
      ],
    },
    chatbotDailyEngagedUsersConsuption: {
      title: 'Chatbots',
      about: 'Track consumption by DEUs via chatbot.',
      columnChatbot: 'ID - Chatbot',
      columnDailyEngagedUsers: 'DEUs',
      buttonAllChatbots: 'See more',
    },
    dailyUsage: {
      title: 'Daily accounting of active users',
      buttonTitle: 'See more',
      tableInformation: 'Below are detailed more information on the contract.',
      byDaily: {
        date: 'Date',
        DailyEngagedUsers: 'DEUs',
      },
    },  
  },
  es: {
    header: 'Contrato de DEU de {0}',
    locale: 'es-ES',
    currency: 'BRL',
    monthPlaceholder: 'Mes',
    compiledDailyEngagedUsersInformation: {
      title: 'Consumo por DEUs (Usuarios Activos Diarios)',
      partialUsage: 'Consumo parcial',
      about: 'Del {0} al {1}',
      noContent: 'Los datos de {0} estarán disponibles a partir del 2.',
      planInformation: 'Plano {0} DEUs',
      filter: 'Utilice el filtro para ver el número total de agentes activados cada mes.',
      spentPercentage: '{0}% de las DEUs utilizadas incluidos en el plan',
      overspentMessages: 'DEU excedentes',
      progressContentHoverIcon: 'Daily Engaged Users (DEU) usuarios activos diarios (DEU) se contabilizan una sola vez, cuando los usuarios contactan con el chatbot en un periodo comprendido entre las 00:00 y las 23:59 del mismo día.',
      totalUsed: 'Total utilizado',
      overspentWarningMessage: 'El límite de DEU del plan ha terminado.',
      overspentWarningFeeDetails: '¡Pero puedes seguir usando tu plan! Los DEUs se están contabilizando.',
      overspentWarningFeeDetailsWithValues: '¡Pero puedes seguir usando tu plan! Se cobrará {0} por cada DEU excedente.',      
      baseValueLabel: 'Valor base del plan',
      totalMonthlyLabel: 'DEU totales por mes',
      totalMonthlyValue: '{0} DEUs',
      overspentCostLabel: 'Costo por DEU excedentes',
      overspentCostValue: '{0} por DEU',
      month: [
        'Enero',
        'Febrero',
        'Marzo',
        'Abril',
        'Mayo',
        'Junio',
        'Julio',
        'Agosto',
        'Septiembre',
        'Octubre',
        'Noviembre',
        'Diciembre',
      ],
    },
    chatbotDailyEngagedUsersConsuption: {
      title: 'Chatbots',
      about: 'Seguimiento del consumo de DEU por chatbot.',
      columnChatbot: 'ID - Chatbot',
      columnDailyEngagedUsers: 'DEUs',
      buttonAllChatbots: 'Ver más',
    },
    dailyUsage: {
      title: 'Contabilidad diaria de usuarios activos',
      buttonTitle: 'Ver más',
      tableInformation: 'A continuación se detalla más información sobre el contrato.',
      byDaily: {
        date: 'Data',
        DailyEngagedUsers: 'DEUs',
      },
    }, 
  },
};
